import * as Sentry from '@sentry/browser';

import { appVersion, appStage } from './constants';
import { getAnalyticsClient } from 'services';
import { Logger } from 'services/logging';
import { GetUserQuery } from 'services/apollo/queries';
import { Storage } from 'services';
import { datadogLogs } from '@datadog/browser-logs';

export const trackError = (errorMessage: any, errorData: any) => {
  if (appStage === 'dev' || appStage === 'prod') {
    // Datadog
    datadogLogs.logger.error(errorMessage, { errorData: JSON.stringify(errorData) });

    // Sentry
    if (Storage.get('t-id')) {
      Sentry.withScope((scope) => {
        scope.setUser({ email: atob(Storage.get('t-id') as string) });
        scope.setTag('FYI-Version', appVersion);
        scope.setExtras(errorData);
        Sentry.captureException(errorMessage);
      });
    } else {
      const getUserInformation = getAnalyticsClient().then((client) =>
        client.query({
          query: GetUserQuery,
          fetchPolicy: 'cache-first',
        })
      );
      getUserInformation
        .then((response) => {
          Sentry.withScope((scope) => {
            scope.setUser({ email: response.data.me.userProfile.email });
            scope.setTag('FYI-Version', appVersion);
            scope.setExtras(errorData);
            Sentry.captureException(errorMessage);
          });
        })
        .catch(() => {
          Sentry.withScope((scope) => {
            scope.setTag('FYI-Version', appVersion);
            scope.setExtras(errorData);
            Sentry.captureException(errorMessage);
          });
        });
    }
  }

  Logger.log(errorMessage, JSON.stringify(errorData));
};

export const errorMessage = {
  CallbackA: 'CallbackA: Request to turn access code into refresh token failed (Login Interrupted)',
  CallbackB: 'CallbackB: Request for organizationId failed (Login Interrupted)',
  CreateOrgError: 'CreateOrgError: Could not create organization',
  GraphQLError: 'GraphQL Error',
  NetworkError: 'Network Error',
  FetchMoreError: 'FetchMoreInFeed Error',
  FailedToShare: 'Sharing Error',
  UnauthenticatedCodeFromServer: 'Unauthenticated GraphQL code from server, logout inititated',
  TokenRefreshRejected:
    'TokenRefresh: 400 Status code. Server rejected token refresh request. Logout Initiated',
  TokenRefreshFailure:
    'TokenRefresh: Failed to get a succesfull response, or a 400 from server after multiple retries',
  FailedToSaveTokens: 'Failed to save new tokens to storage',
  FailedToSaveGroupInvite: 'Group invite failed to save for unauthenticated user',
  Logout: 'Log out',
};
